import styled from 'styled-components';
import { NotesIcon } from '../../Icons';

export const Container = styled.div`

    .modal-body {
        height: 500px;
    }

    .annotations-wrapper {
        width: 100%;
        height: 100%;
    }
`;

export const AnnotationsIcon = styled(NotesIcon)`
    fill: ${(props) => props.theme.cardAnnotations.iconColor};
`;
